import { render } from "./AddTypeChargementPage.vue?vue&type=template&id=6bb825fb&ts=true"
import script from "./AddTypeChargementPage.vue?vue&type=script&lang=ts"
export * from "./AddTypeChargementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__